import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { isMobile, notMobile } from '@libraries/ui-state';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { rollUpAnimation } from '../../animations';

export enum Language {
  English = 'eng',
  Espanol = 'esp',
}

interface ProgramGuidelinesUrl {
  english: string;
  spanish: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [rollUpAnimation('rollUp', '6rem', '0.32s ease', '0.32s ease')],
  standalone: false,
})
export class AppHeaderComponent {
  @Input() showContent = false;
  @Input() hidePortal = false;
  @Input() hidePhone = false;
  @Input() showMoreAction = true;
  @Input() showPaceGuidelines = false;
  @Input() showPaceGuidelinesWithText = false;
  @Input() paceGuidelinesOnlyInMoreMenu = false;
  @Input() showLanguageToggler = false;
  @Input() showSpanishDocuments = false;
  @Input() programGuidelinesUrl: ProgramGuidelinesUrl = {
    english: '',
    spanish: '',
  };
  @Input() currentLanguage = Language.English;
  @Input() largeDesktopLogo = false;
  @Input() tabletLogo = false;
  @Input() showLogo = true;
  @Input() logoUrl = 'https://ygrene.com/';
  @Input() loginUrl = 'https://ygrene.com/login';
  @Input() userTypeContractor = false;
  @Output() languageChange = new EventEmitter<Language>();
  Language = Language;
  @Input() isMiniApp = false;

  isNotMobile$ = this.store.select(notMobile);
  isMobile$ = this.store.select(isMobile);
  @Input() showTucieloLogo: boolean | undefined;
  @Input() showHoaLogo = false;
  tucieloAquaLogoShow = false;

  @ViewChild('moreActions') moreActionsTrigger?: MatMenuTrigger;
  @ViewChild('paceGuidelinesFromMore') paceGuidelinesFromMoreTrigger?: MatMenuTrigger;
  private openGuidelinesAfterMoreCloses?: Subscription;

  constructor(private store: Store) {}

  ngOnInit() {
    if (this.showTucieloLogo) this.tucieloAquaLogoShow = this.showTucieloLogo ? true : false;
  }

  onLanguageChange(language: Language) {
    this.languageChange.emit(language);
  }

  openPaceGuidelinesFromMoreMenu(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    const moreActions = this.moreActionsTrigger;
    const guidelines = this.paceGuidelinesFromMoreTrigger;
    if (!moreActions || !guidelines) {
      return;
    }

    this.openGuidelinesAfterMoreCloses?.unsubscribe();
    this.openGuidelinesAfterMoreCloses = moreActions.menuClosed.subscribe(() => {
      this.openGuidelinesAfterMoreCloses?.unsubscribe();
      this.openGuidelinesAfterMoreCloses = undefined;
      guidelines.openMenu();
    });
    moreActions.closeMenu();
  }
}
